import React from 'react';
import { getEmblemImageUrl } from '../../utils/formatters';
import './FlairStyles.css';

/**
 * En spelares utrustade emblem (butikens flair, omgång 3).
 *
 * Emblemet är en AI-genererad bild och inte ett tecken — därav ett eget fält
 * (`Player.flair_emblem`) och en egen komponent i stället för `flair_badge`,
 * som bara rymmer 16 tecken.
 *
 * Renderas som syskon till namnet, aldrig inuti det: namnstilarna klipper sin
 * bakgrund mot texten (`background-clip: text` med genomskinlig färg), och en
 * bild inuti den kedjan riskerar att ärva rendering som är avsedd för glyfer.
 *
 * Storleken är 32 px och matchar spelaravataren med flit. Ett större emblem
 * blir radens huvudperson och trycker ned ansiktet — flairen ska vara ett
 * attribut hos spelaren, inte tvärtom.
 *
 * @param {object} props
 * @param {string|null|undefined} props.emblem - `flair_emblem` från API:t
 *   (filnamnsstam). Tomt värde renderar ingenting.
 * @param {string} [props.title] - Tooltip, vanligen emblemets namn.
 * @param {string} [props.className] - Extra klass för avvikande storlek.
 * @returns {JSX.Element|null} Bilden, eller null när inget emblem bärs.
 */
const FlairEmblem = ({ emblem, title, className = '' }) => {
  const url = getEmblemImageUrl(emblem);
  if (!url) return null;
  return (
    <img
      src={url}
      alt=""
      title={title || emblem}
      className={`flair-emblem ${className}`.trim()}
      loading="lazy"
      // Ett avlistat eller omdöpt motiv ska inte lämna ett brutet bildkryss
      // vid nicket — emblemet är dekor, och dekor som saknas ska försvinna.
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
    />
  );
};

export default FlairEmblem;
